export default "__VITE_ASSET__fa8171ee__"